import { Component } from '@angular/core';

@Component({
  selector: 'ui-timeline',
  templateUrl: './timeline.component.html'
})
export class TimelineComponent {
}